import angular from 'angular';
import uiRouter from 'angular-ui-router';
import cardRequestFailureComponent from './cardRequestFailure.component';

let cardRequestFailureModule = angular.module('cardRequestFailure', [
  uiRouter
])

.component('cardRequestFailure', cardRequestFailureComponent)

.name;

export default cardRequestFailureModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardRequestFailure/cardRequestFailure.js